/*
    © 2023 EcomGraduates.com — modifié pour Secrets Of Amber
    - paliers en nombre de modèles ou en montant
    - 1 modèle = 1 fois (bouton « Choisi », re-clic = retirer)
*/

const SOA_B = window.ecomify_bundle || { tiers: '2:10,3:15', type: 'quantity', unique: true, text: {} }
const SOA_T = Object.assign({
    add: '+ Ajouter au pack',
    added: 'Ajouté ✓',
    chosen: '✓ Choisi · retirer',
    uncompleted: 'Encore [count] pour profiter de [percentage] de remise',
    completed: 'Bravo ! [percentage] de remise sur votre pack',
    atc: 'Ajouter mon pack au panier',
    singular: 'modèle',
    plural: 'modèles'
}, SOA_B.text || {})

const isQtyMode = () => SOA_B.type !== 'amount'

const getBundleContents = () => {
    try { return JSON.parse(localStorage.getItem('ecomify-bundle-v2') || '[]') } catch (e) { return [] }
}

const saveBundleContents = (contents) => {
    localStorage.setItem('ecomify-bundle-v2', JSON.stringify(contents))
}

const getTiers = () => {
    return String(SOA_B.tiers || '')
        .split(',')
        .map(t => {
            const parts = t.split(':')
            return { v: Number(String(parts[0]).trim()), d: Number(String(parts[1]).trim()) }
        })
        .filter(t => !isNaN(t.v) && !isNaN(t.d))
        .sort((a, b) => a.v - b.v)
}

// valeur d'un palier dans l'unité de mesure (nombre de modèles, ou centimes)
const tierThreshold = (tier) => isQtyMode() ? tier.v : tier.v * 100

const bundleMetric = (contents) => isQtyMode()
    ? contents.reduce((a, c) => a + c.quantity, 0)
    : contents.reduce((a, c) => a + c.variant_price * c.quantity, 0)

const formatRemaining = (n) => {
    if (!isQtyMode()) return Shopify.formatMoney(n)
    return n + ' ' + (n > 1 ? SOA_T.plural : SOA_T.singular)
}

// Init Bundle
const initBundle = () => {
    const contents = getBundleContents()
    const tiers = getTiers()
    if (!tiers.length) return

    const totalPrice = contents.reduce((a, c) => a + c.variant_price * c.quantity, 0)
    const metric = bundleMetric(contents)
    const maxValue = tierThreshold(tiers[tiers.length - 1])
    const reached = tiers.filter(t => metric >= tierThreshold(t)).pop()
    const next = tiers.find(t => metric < tierThreshold(t))

    document.querySelectorAll('.bundle-progress').forEach(progress => {
        const progressBar = progress.querySelector('.progress-bar')
        const progressText = progress.closest('.bundle-progress-wrapper').querySelector('.progress-text')
        const width = Math.min(100, Math.round(metric / maxValue * 100))

        progressBar.style.width = width + '%'
        progressBar.setAttribute('aria-valuenow', width)

        if (next) {
            progressBar.classList.remove(progressBar.dataset.colorCompleted)
            progressBar.classList.add(progressBar.dataset.colorUncompleted)
            const remaining = tierThreshold(next) - metric
            let txt = SOA_T.uncompleted
            txt = txt.replace('[count]', `<b>${formatRemaining(remaining)}</b>`)
            txt = txt.replace('[value]', `<b>${formatRemaining(remaining)}</b>`)
            txt = txt.replace('[percentage]', `<b>-${next.d}%</b>`)
            if (progressText) {
                progressText.innerHTML = txt
                progressText.classList.remove(progressBar.dataset.colorCompleted.replace('bg-', 'text-'))
            }
        } else {
            progressBar.classList.remove(progressBar.dataset.colorUncompleted)
            progressBar.classList.add(progressBar.dataset.colorCompleted)
            let txt = SOA_T.completed.replace('[percentage]', `<b>-${tiers[tiers.length - 1].d}%</b>`)
            if (progressText) {
                progressText.innerHTML = txt
                progressText.classList.add(progressBar.dataset.colorCompleted.replace('bg-', 'text-'))
            }
        }
    })

    document.querySelectorAll('.bundle-btn-atc').forEach(btn => {
        btn.disabled = contents.length === 0
    })

    document.querySelectorAll('[data-bundle-price]').forEach(elem => {
        if (reached && totalPrice > 0) {
            const price = Shopify.formatMoney(Math.round((1 - reached.d / 100) * totalPrice))
            elem.innerHTML = `<s class="text-muted fw-normal">${Shopify.formatMoney(totalPrice)}</s> ${price}`
        } else {
            elem.innerHTML = Shopify.formatMoney(totalPrice)
        }
    })

    document.querySelectorAll('[data-bundle-discount]').forEach(elem => {
        const d = reached ? reached.d : 0
        elem.innerHTML = `${Shopify.formatMoney(Math.round(d / 100 * totalPrice))} (${d}%)`
    })

    document.querySelectorAll('[data-bundle-count]').forEach(elem => {
        if (!isQtyMode()) { elem.textContent = ''; return }
        elem.textContent = `· ${metric} ${metric > 1 ? SOA_T.plural : SOA_T.singular}`
    })

    updateBundleCards(contents)
    initBundleContents()
}

// Etat des boutons sur les cartes produits
const updateBundleCards = (contents) => {
    document.querySelectorAll('form').forEach(form => {
        const pid = form.querySelector('[name="product_id"]')
        if (!pid) return
        const inBundle = contents.some(c => c.product_id === Number(pid.value))
        form.querySelectorAll('.btn-atc').forEach(btn => {
            if (btn.dataset.soaFlash === '1') return
            if (SOA_B.unique && inBundle) {
                btn.innerHTML = SOA_T.chosen
                btn.classList.add('soa-chosen')
            } else {
                btn.innerHTML = SOA_T.add
                btn.classList.remove('soa-chosen')
            }
        })
        const card = form.closest('.product-item')
        if (card) card.classList.toggle('soa-in-bundle', inBundle)
    })
}

document.addEventListener('DOMContentLoaded', initBundle)
if (document.readyState !== 'loading') initBundle()
window.addEventListener('updated.ecomify.collection', initBundle)

// 'Add to bundle' form
window.onSubmitBundleForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.btn-atc')
    const productId = Number(form.querySelector('[name="product_id"]').value)
    const productTitle = form.querySelector('[name="product_title"]').value
    const variantId = Number(form.querySelector('[name="id"]').value)
    const variantTitle = form.querySelector('[name="variant_title"]').value
    const variantPrice = Number(form.querySelector('[name="variant_price"]').value)
    const variantImage = form.querySelector('[name="variant_image"]').value

    let contents = getBundleContents()

    // Mode « 1 modèle une seule fois » : re-cliquer retire le modèle
    if (SOA_B.unique && contents.some(c => c.product_id === productId)) {
        contents = contents.filter(c => c.product_id !== productId)
        saveBundleContents(contents)
        initBundle()
        return
    }

    if (!SOA_B.unique && contents.find(c => c.variant_id === variantId)) {
        contents = contents.map(c => {
            if (c.variant_id === variantId) c.quantity += 1
            return c
        })
    } else {
        contents.push({
            product_id: productId,
            product_title: productTitle,
            variant_id: variantId,
            variant_title: variantTitle,
            variant_price: variantPrice,
            variant_image: variantImage,
            quantity: 1
        })
    }

    saveBundleContents(contents)

    if (btn) {
        btn.dataset.soaFlash = '1'
        btn.innerHTML = SOA_T.added
        btn.classList.add('animate__animated', 'animate__pulse')
        setTimeout(() => {
            btn.dataset.soaFlash = ''
            btn.classList.remove('animate__animated', 'animate__pulse')
            initBundle()
        }, 900)
    }

    initBundle()
}

// Add to bundle form based on variant
window.onClickBundleFormVariant = async (btn, event) => {
    const form = btn.closest('form')

    form.querySelector('[name="id"]').value = btn.dataset.variantId
    form.querySelector('[name="variant_price"]').value = btn.dataset.variantPrice
    form.querySelector('[name="variant_image"]').value = btn.dataset.variantImage
    form.querySelector('[name="variant_title"]').value = btn.dataset.variantTitle

    window.onSubmitBundleForm(form, event)
}

// Add Bundle Contents to Cart
window.addBundleContentsToCart = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Chargement…</span>
        </div>
    `

    const items = getBundleContents().map(c => ({ id: c.variant_id, quantity: c.quantity }))

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
    })

    const modalEl = document.querySelector('#bundle-contents-modal')
    if (modalEl) bootstrap.Modal.getOrCreateInstance(modalEl).hide()

    localStorage.removeItem('ecomify-bundle-v2')
    initBundle()

    if (btn.dataset.redirectToCheckout === 'true') {
        window.location.href = '/checkout'
    } else {
        btn.innerHTML = (window.theme && window.theme.product && window.theme.product.addedToCart) || 'Ajouté au panier'

        setTimeout(() => {
            btn.innerHTML = btn.dataset.textAddToCart || SOA_T.atc
        }, 2000)

        if (window.refreshCartContents) window.refreshCartContents(response)
        const cart = document.querySelector('#offcanvas-cart')
        if (cart) bootstrap.Offcanvas.getOrCreateInstance(cart).show()
    }
}

// Sticky bundle card on desktop
const initStickyBundleCard = () => {
    const card = document.querySelector('#bundle-card')

    if (!card) return

    if (window.matchMedia('(min-width: 992px)').matches) {
        const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
        const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

        card.style.position = 'sticky'
        card.style.zIndex = '1'
        card.style.top = `${navbarHeight + announcementBarHeight + 20}px`

        if (window.throttle) {
            window.addEventListener('scroll', window.throttle(() => {
                const utils = document.querySelector('#collection-utilities')
                if (utils && utils.classList.contains('sticky-top')) {
                    card.style.top = `${navbarHeight + announcementBarHeight + 82}px`
                } else {
                    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
                }
            }, 200))
        }
    }
}
initStickyBundleCard()

// Bundle Contents Modal
function initBundleContents () {
    const modal = document.querySelector('#bundle-contents-modal')
    if (!modal) return

    const contents = getBundleContents()
    const list = modal.querySelector('.product-list')

    if (contents.length === 0) {
        modal.querySelector('.bundle-contents-empty').removeAttribute('hidden')
        list.setAttribute('hidden', 'hidden')
        return
    }

    let listHtml = ''

    contents.forEach(elem => {
        const qtyControls = SOA_B.unique ? '' : `
            <div class="quantity-wrapper">
                <button class="btn" type="button" data-mode="minus" onclick="onClickQtyPlusMinus(this)" aria-label="${list.dataset.textDecreaseQty}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
                <input class="form-control" type="text" value="${elem.quantity}" data-min-qty="0" data-variant-id="${elem.variant_id}" aria-label="${list.dataset.textQuantity}" onchange="onChangeBundleItemQty(this)">
                <button class="btn btn-plus" type="button" data-mode="plus" onclick="onClickQtyPlusMinus(this)" aria-label="${list.dataset.textIncreaseQty}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
            </div>`

        listHtml += `
            <li class="product-item py-3">
                <div class="row align-items-center mx-n3">
                    <div class="col-4 px-3">
                        <img 
                            class="product-item-img img-fluid rounded ${list.dataset.imgThumbnail}" 
                            src="${Shopify.resizeImage(elem.variant_image || 'no-image.gif', `${list.dataset.imgWidth}x${list.dataset.imgHeight}`, 'center')}"
                            alt="" 
                            width="${list.dataset.imgWidth}"
                            height="${list.dataset.imgHeight}"
                            loading="lazy">
                    </div>
                    <div class="col-8 px-3">
                        <h3 class="product-item-title h6 mb-2">${elem.product_title}</h3>
                        <p class="small text-muted mt-n1 mb-2" ${elem.variant_title.includes('Default Title') ? 'hidden' : ''}>${elem.variant_title}</p>
                        <p class="product-item-price-final mb-3">${Shopify.formatMoney(elem.variant_price)}</p>
                        <div class="d-flex align-items-center">
                            ${qtyControls}
                            <button 
                                class="btn-remove btn btn-sm ${SOA_B.unique ? '' : 'ms-2'}"
                                onclick="onRemoveBundleItem(this)"
                                data-variant-id="${elem.variant_id}"
                                aria-label="${list.dataset.textRemove}"
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                                <span class="ms-1 small">${list.dataset.textRemove}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </li>
        `
    })

    list.innerHTML = listHtml
    list.removeAttribute('hidden')
    modal.querySelector('.bundle-contents-empty').setAttribute('hidden', 'hidden')
}

// Quantity change (bundle contents)
window.onChangeBundleItemQty = (input) => {
    let contents = getBundleContents()

    if (Number(input.value) === 0) {
        contents = contents.filter(c => c.variant_id !== Number(input.dataset.variantId))
    } else {
        contents = contents.map(c => {
            if (c.variant_id === Number(input.dataset.variantId)) c.quantity = Number(input.value)
            return c
        })
    }

    saveBundleContents(contents)
    initBundle()
}

// Remove bundle items (bundle contents)
window.onRemoveBundleItem = (btn) => {
    const contents = getBundleContents().filter(c => c.variant_id !== Number(btn.dataset.variantId))
    saveBundleContents(contents)
    initBundle()
}

/*
    Sticky Bundle Card on mobile
*/
const initStickyBundleCardMobile = async () => {
    const wrapper = document.querySelector('#bundle-card-sticky-mobile')
    const card = document.querySelector('#bundle-card')

    if (!wrapper || !card) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = card.getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
            document.body.style.paddingBottom = wrapper.clientHeight + 'px'
        } else {
            wrapper.classList.remove('show')
            document.body.style.paddingBottom = 0
        }
    })
}
initStickyBundleCardMobile()
